import ServiceQuality from "./ServiceQuality"

export default ServiceQuality